<script>
import { Line } from 'vue-chartjs'

const DEFAULT_CHART_OPTIONS = Object.freeze({
  responsive: true,
  maintainAspectRatio:false,
  elements: {
    point:{
      radius: 0
    }
  },
  legend: {
    labels: {
      fontColor: '#ffffff',
      fontSize: 18
    }
  },
  scales: {
    xAxes: [{
      type: 'time',
      time: {
        unit: 'day'
      },
      ticks: {
        autoSkip: true,
        maxTicksLimit: 7
      }
    }]
  }
})

export default {
  extends: Line,

  props: {
    chartdata: {
      type: Object,
      required: true
    },
    options: {
      type: Object,
      required: false
    }
  },

  async mounted () {
    this.renderChart(
      this.chartdata,
      Object.assign({}, DEFAULT_CHART_OPTIONS, this.options)
    )
  },

  watch: {
    chartdata () {
      this.renderChart(
        this.chartdata,
        Object.assign({}, DEFAULT_CHART_OPTIONS, this.options)
      )
    }
  }
}
</script>

<style>
</style>